import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HomePage from './components/HomePage';
import CurrentProjects from './components/CurrentProjects';
import NotFound from './components/NotFound';
import StickyContact from './components/StickyContact';
import CookieConsent from './components/CookieConsent';
import InstallPrompt from './components/InstallPrompt';
import './App.css';

function App() {
  return (
    <div className="app">
      <a href="#main-content" className="skip-to-content">
        Skip to main content
      </a>
      <Header />
      <main id="main-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/projects" element={<CurrentProjects />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <InstallPrompt />
      <StickyContact />
      <CookieConsent />
    </div>
  );
}

export default App;
